import { createBrowserRouter } from 'react-router-dom';

import { AppRoot } from '~navigation/roots/app-root';
import { NotFoundPage } from '~navigation/pages/not-found-page';
import { SearchPage } from '~navigation/pages/search-page';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppRoot />,
    children: [
      { index: true, element: <SearchPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
